import { render } from "./LoginPassword.vue?vue&type=template&id=5b335204&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=5b335204&lang=scss&scoped=true"
import "./LoginPassword.vue?vue&type=style&index=1&id=5b335204&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b335204"]])

export default __exports__